// ============================================
// CONTENT DATA - EDIT THIS FILE TO CHANGE TEXT
// ============================================

export const content = {
  en: {
    // Navigation
    nav: {
      logo: "Al-Ghuwaizi Tuna UAE",
      enButton: "EN",
      arButton: "AR",
      menu: {
        home: "Home",
        about: "About",
        where: "Where to Buy",
        wholesale: "Wholesale"
      }
    },
    
    // Hero Section
    hero: {
      headline: "Exclusive Agent of Al-Ghuwaizi Tuna in the UAE",
      subheadline: "Premium Yemeni Tuna with World-Class Quality Since 1979",
      description: "We are the exclusive agent of Al-Ghuwaizi Tuna in the United Arab Emirates, supplying wholesalers and distributors with high-quality Yellowfin Tuna, canned in Al Mukalla Canning Factory – Yemen, established in 1979 and recognized as one of the oldest and most reputable tuna canneries in the region.",
      descriptionExtra: "Al-Ghuwaizi Tuna is known for its rich natural taste, consistent quality, and being free from artificial preservatives, making it an ideal choice for the UAE market seeking healthy, reliable, and easy-to-sell canned tuna products.",
      orderButton: "Order Now",
      whatsappButton: "WhatsApp Us"
    },
    
    // Preservative Free Section
    preservativeFree: {
      title: "100% Preservative Free",
      subtitle: "Our tuna is completely natural - no artificial preservatives, no additives, just pure premium quality tuna from the pristine waters of Hadhramout.",
      features: [
        "No Artificial Preservatives",
        "No Chemical Additives",
        "No Artificial Colors",
        "100% Natural Ingredients"
      ],
      tagline: "Pure & Natural - The Way Tuna Should Be"
    },

    // About Section
    about: {
      title: "Why Do Traders Choose Al-Ghuwaizi Tuna?",
      features: [
        {
          icon: "award",
          title: "Long Heritage & Proven Reliability",
          description: "Over 45 years of expertise in fishing and canning tuna from the pristine coasts of Hadhramout.",
          color: "#10B981"
        },
        {
          icon: "heart",
          title: "Quality That Competes with Global Brands",
          description: "Premium Yellowfin Tuna, rich in protein and Omega-3, with firm texture and natural flavor.",
          color: "#EF4444"
        },
        {
          icon: "leaf",
          title: "Strong Competitive Advantage in UAE Market",
          description: "A premium Arabic alternative to Asian tuna brands, with growing demand among Arab and international communities and health-conscious consumers.",
          color: "#FDEC3C"
        },
        {
          icon: "fish",
          title: "Exclusive Agency & Full Trade Support",
          description: "Stable supply, competitive wholesale pricing, and marketing support to accelerate product turnover at points of sale.",
          color: "#3B82F6"
        }
      ]
    },
    
    // Counter Section
    counter: {
      mainNumber: "100+",
      mainText: "Trusted Customers Across UAE",
      stats: [
        { number: "45+", label: "Years Experience" },
        { number: "7", label: "Emirates Covered" },
        { number: "100%", label: "Satisfaction Rate" }
      ]
    },
    
    // Where to Buy Section
    whereToBuy: {
      title: "Your Trusted Tuna Distribution Partner in the UAE",
      subtitle: "We provide consistent supply, attractive profit margins, and a strong brand with a rich story and powerful market identity.",
      locations: [
        {
          icon: "store",
          title: "Supermarket Chains",
          color: "#BF0A1D"
        },
        {
          icon: "shoppingBag",
          title: "Wholesalers & Distributors",
          color: "#10B981"
        },
        {
          icon: "fish",
          title: "Food Retailers & Restaurants",
          color: "#3B82F6"
        }
      ],
      locationsTitle: "UAE Locations",
      cities: [
        { name: "Dubai", icon: "🏙️" },
        { name: "Abu Dhabi", icon: "🌆" },
        { name: "Sharjah", icon: "🏘️" }
      ],
      mapImage: "" // Optional: Add map image URL here
    },
    
    // Wholesale Form
    wholesale: {
      title: "Contact Us Now",
      subtitle: "Join the growing distribution network of Al-Ghuwaizi Tuna in the UAE.",
      form: {
        name: "Full Name",
        company: "Company Name",
        phone: "Phone / WhatsApp",
        email: "Email Address",
        city: "City",
        quantity: "Estimated Quantity",
        message: "Additional Message",
        submitButton: "Submit Wholesale Request",
        successMessage: "✓ Request submitted successfully!",
        errorMessage: "Error submitting form. Please try again.",
        validation: {
          nameRequired: "Name is required",
          nameMinLength: "Name must be at least 2 characters",
          phoneRequired: "Phone number is required",
          phoneInvalid: "Invalid phone number",
          phoneTooShort: "Phone number is too short",
          emailRequired: "",
          emailInvalid: "Invalid email address",
          cityRequired: "City is required",
          quantityRequired: "Quantity is required"
        }
      },
      cities: [
        "Dubai",
        "Abu Dhabi",
        "Sharjah",
        "Ajman",
        "Ras Al Khaimah",
        "Fujairah",
        "Umm Al Quwain"
      ],
      quantities: [
        "10 - 100 cartons",
        "100 - 500 cartons",
        "500 - 1,000 cartons",
        "1,000+ cartons"
      ]
    },
    
    // Footer
    footer: {
      tagline: "Premium Yemeni Tuna • Since 1979",
      description: "Exclusive agent of Al-Ghuwaizi Tuna in the UAE – known for its rich natural taste, consistent quality, and being free from artificial preservatives.",
      followTitle: "Follow Us",
      contactTitle: "Contact Us",
      locationLabel: "Location",
      location: "United Arab Emirates",
      copyright: "© 2026 Al-Ghuwaizi Tuna UAE. All rights reserved.",
      social: {
        instagram: "https://instagram.com/mab_tunagwaizi_uae/",
        facebook: "#",
        tiktok: "#",
        email: "mailto:info@tunagwaizi-uae.com"
      }
    }
  },
  
  ar: {
    // Navigation
    nav: {
      logo: "تونة الغويزي في الإمارات",
      enButton: "EN",
      arButton: "AR",
      menu: {
        home: "الرئيسية",
        about: "من نحن",
        where: "أين تجدنا",
        wholesale: "الجملة"
      }
    },
    
    // Hero Section
    hero: {
      headline: "الوكيل الحصري لتونا الغويزي في الإمارات",
      subheadline: "تونة يمنية عريقة بجودة عالمية منذ 1979",
      description: "نحن الوكيل الحصري لعلامة تونا الغويزي في دولة الإمارات العربية المتحدة، نوفر لتجار الجملة والموزعين تونة صفراء (Yellowfin Tuna) عالية الجودة، معلبة في مصنع المكلا لتعليب الأسماك - اليمن منذ عام 1979، أحد أقدم وأعرق مصانع التونة في العالم.",
      orderButton: "اطلب الآن",
      whatsappButton: "تواصل واتساب"
    },
    
    // Preservative Free Section
    preservativeFree: {
      title: "خالية 100% من المواد الحافظة",
      subtitle: "تونة طبيعية بالكامل - بدون مواد حافظة صناعية، بدون إضافات كيميائية، فقط تونة فاخرة نقية من مياه حضرموت الصافية.",
      features: [
        "بدون مواد حافظة صناعية",
        "بدون إضافات كيميائية",
        "بدون ألوان صناعية",
        "مكونات طبيعية 100%"
      ],
      tagline: "نقية وطبيعية - التونة كما يجب أن تكون"
    },

    // About Section
    about: {
      title: "لماذا يختار التجار تونا الغويزي؟",
      features: [
        {
          icon: "award",
          title: "تاريخ عريق وموثوقية عالية",
          description: "خبرة أكثر من 45 عاماً في صيد وتعليب التونة من سواحل حضرموت.",
          color: "#10B981"
        },
        {
          icon: "heart",
          title: "جودة تنافس العلامات العالمية",
          description: "تونة الزعنفة الصفراء الغنية بالبروتين والأوميغا 3، بقوام متماسك ونكهة طبيعية.",
          color: "#EF4444"
        },
        {
          icon: "leaf",
          title: "ميزة تنافسية في سوق الإمارات",
          description: "بديل عربي فاخر للتونة الآسيوية، بطلب متزايد لدى الجاليات العربية والمستهلكين المهتمين بالغذاء الصحي.",
          color: "#FDEC3C"
        },
        {
          icon: "fish",
          title: "وكالة حصرية ودعم تجاري",
          description: "توريد مستقر، أسعار جملة منافسة، ودعم تسويقي يعزز سرعة دوران المنتج في نقاط البيع.",
          color: "#3B82F6"
        }
      ]
    },
    
    // Counter Section
    counter: {
      mainNumber: "100+",
      mainText: "أكثر من 100 عميل يثقون بنا في الإمارات",
      stats: [
        { number: "45+", label: "سنوات خبرة" },
        { number: "7", label: "إمارات مغطاة" },
        { number: "100%", label: "نسبة رضا" }
      ]
    },
    
    // Where to Buy Section
    whereToBuy: {
      title: "شريكك في توزيع التونة في الإمارات",
      subtitle: "نحن نعمل مع تجار الجملة، الموزعين، سلاسل السوبرماركت، المتاجر الغذائية، والمطاعم",
      locations: [
        {
          icon: "store",
          title: "سلاسل السوبرماركت",
          color: "#BF0A1D"
        },
        {
          icon: "shoppingBag",
          title: "تجار الجملة والموزعين",
          color: "#10B981"
        },
        {
          icon: "fish",
          title: "المتاجر الغذائية والمطاعم",
          color: "#3B82F6"
        }
      ],
      locationsTitle: "مواقع الإمارات",
      cities: [
        { name: "دبي", icon: "🏙️" },
        { name: "أبوظبي", icon: "🌆" },
        { name: "الشارقة", icon: "🏘️" }
      ],
      mapImage: "" // Optional: Add map image URL here
    },
    
    // Wholesale Form
    wholesale: {
      title: "تواصل معنا الآن",
      subtitle: "للانضمام إلى شبكة نقاط بيع تونا الغويزي في الإمارات. توريد منتظم، هوامش ربح مستقرة، وعلامة تجارية ذات قصة وهوية تسويقية قوية.",
      form: {
        name: "الاسم الكامل",
        company: "اسم الشركة",
        phone: "الهاتف / واتساب",
        email: "البريد الإلكتروني",
        city: "المدينة",
        quantity: "الكمية المتوقعة",
        message: "رسالة إضافية",
        submitButton: "إرسال طلب الجملة",
        successMessage: "✓ تم إرسال الطلب بنجاح!",
        errorMessage: "خطأ في إرسال النموذج. يرجى المحاولة مرة أخرى.",
        validation: {
          nameRequired: "الاسم مطلوب",
          nameMinLength: "الاسم يجب أن يكون على الأقل حرفين",
          phoneRequired: "رقم الهاتف مطلوب",
          phoneInvalid: "رقم الهاتف غير صحيح",
          phoneTooShort: "رقم الهاتف قصير جداً",
          emailRequired: "",
          emailInvalid: "البريد الإلكتروني غير صحيح",
          cityRequired: "المدينة مطلوبة",
          quantityRequired: "الكمية مطلوبة"
        }
      },
      cities: [
        "دبي",
        "أبوظبي",
        "الشارقة",
        "عجمان",
        "رأس الخيمة",
        "الفجيرة",
        "أم القيوين"
      ],
      quantities: [
        "10 - 100 كرتون",
        "100 - 500 كرتون",
        "500 - 1,000 كرتون",
        "أكثر من 1,000 كرتون"
      ]
    },
    
    // Footer
    footer: {
      tagline: "تونة يمنية فاخرة • منذ 1979",
      description: "الوكيل الحصري لتونا الغويزي في الإمارات – تتميز بطعمها الطبيعي الغني، وجودتها الثابتة، وخلوّها من المواد الحافظة الصناعية.",
      followTitle: "تابعنا",
      contactTitle: "اتصل بنا",
      locationLabel: "الموقع",
      location: "الإمارات العربية المتحدة",
      copyright: "© 2026 تونة الغويزي الإمارات. جميع الحقوق محفوظة.",
      social: {
        instagram: "https://instagram.com/mab_tunagwaizi_uae/",
        facebook: "#",
        tiktok: "#",
        email: "mailto:info@tunagwaizi-uae.com"
      }
    }
  }
};

// ============================================
// COLORS - EDIT THESE TO CHANGE THEME COLORS
// ============================================
export const colors = {
  primary: "#BF0A1D",      // Red - Main brand color
  secondary: "#263C7D",   // Blue - Headings, accents
  accent: "#FDEC3C",      // Yellow - Highlights
  background: "#ffffff",  // White - Background
  text: "#4B5563",        // Gray - Text color
  textLight: "#9CA3AF"    // Light gray - Secondary text
};

// ============================================
// CONFIG - EDIT THESE FOR GENERAL SETTINGS
// ============================================
// NOTE: Phone numbers and email are now in src/data/contact.js
// Edit that file to change contact information
export const config = {
  defaultLanguage: "ar"            // Default language: "en" or "ar"
};
